import { Api } from '../../Api';
import { DataFrame, Status } from "../../DataFrame";
import { IWebApiCacheService } from "./IWebApiCacheService";
import { ILocalStorageService } from '../ILocalStorageService';
import { LocalStorageService } from '../LocalStorageService';
import { ILoggerService } from '../Logging/ILoggerService';
import { LoggerService } from '../Logging/LoggerService';

export class WebApiCacheService implements IWebApiCacheService {
    private static _localStorageService: ILocalStorageService | null = null;
    private _log: ILoggerService = Api.Get<ILoggerService>(LoggerService.ServiceName);
    public static readonly ServiceName: string = "WebApiCacheService";

    constructor() {
        WebApiCacheService._localStorageService = Api.Get<ILocalStorageService>(LocalStorageService.ServiceName);
    }

    GetServiceName(): string {
        return WebApiCacheService.ServiceName;
    }

    private GetResourceName(data: DataFrame<any>): string {
        return `${data.Resource}${data.Method}`;
    }

    Cache(data: DataFrame<any>): void {

        if (data.Status !== Status.OK)
            return;

        this._log.Debug(WebApiCacheService.ServiceName, `Caching request: ${data.Resource} ${data.Method}`);
        WebApiCacheService._localStorageService?.Save(this.GetServiceName(), this.GetResourceName(data), data);
    }

    GetCache(data: DataFrame<any>): DataFrame<any> | null {
        let tmp = WebApiCacheService._localStorageService?.Read<DataFrame<any>>(this.GetServiceName(), this.GetResourceName(data));

        if (tmp != null)
            this._log.Debug(WebApiCacheService.ServiceName, `Got request response from cache: ${data.Resource} ${data.Method}`);

        if (tmp == null)
            return null;

        return {
            ...tmp,
            TransactionId: data.TransactionId,
        };
    }

    ClearCache(): void {
        WebApiCacheService._localStorageService?.DropStorage(this.GetServiceName());
        this._log.Debug(WebApiCacheService.ServiceName, `Clearing cache for ${this.GetServiceName()}`);
    }

    Remove(data: DataFrame<any>): void {
        WebApiCacheService._localStorageService?.Remove(this.GetServiceName(), this.GetResourceName(data));
        this._log.Debug(WebApiCacheService.ServiceName, `Clearing cache for cache: ${data.Resource} ${data.Method}`);
    }
}
